// src/pages/HomePage.styles.js

import styled from 'styled-components'; // Needed for styled components
import BACKGROUND_IMAGE from 'assets/background.jpg'; // Import the background image here
import rocketIcon from 'assets/rocket-icon.png'; // Import rocket icon if StyledMissionList/Item is used here

// --- THEME COLORS ---
export const colors = {
    textColor: '#ffffff',
    accentColor: '#19abf0',
    cardBorder: 'rgba(255, 255, 255, 0.5)',
};

// --- Global Page Layout Styles (Plain JS Objects) ---
export const pageContainerStyles = {
    backgroundImage: `url(${BACKGROUND_IMAGE})`,
    backgroundSize: 'auto', // Tiled pattern
    backgroundPosition: 'center top',
    backgroundRepeat: 'repeat',
    backgroundColor: 'transparent',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingTop: '60px', // Space for fixed Navbar
    color: colors.textColor,
    boxSizing: 'border-box',
    width: '100vw',
    overflowX: 'hidden',
    minHeight: 'calc(var(--app-height, 100vh) + 50vh)',
};

export const footerStyles = {
    width: '100%',
    padding: '20px',
    textAlign: 'center',
    backgroundColor: 'rgba(0,0,0,0.5)',
    color: colors.textColor,
    marginTop: 'auto',
    boxSizing: 'border-box',
    flexShrink: 0,
};

export const introBannerStyles = {
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    color: colors.textColor,
    padding: '20px',
    borderRadius: '10px',
    boxShadow: '0 0 20px rgba(0,0,0,0.7)',
    textAlign: 'center',
    marginTop: '1rem',
    marginBottom: '2rem',
    width: '90%',
    maxWidth: '900px',
    minHeight: '180px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
};

export const introBannerStyles2 = {
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    color: colors.textColor,
    padding: '10px',
    borderRadius: '10px',
    border: '1px solid white',
    boxShadow: '0 0 20px rgba(0,0,0,0.7)',
    textAlign: 'center',
    marginTop: '1rem',
    marginBottom: '2rem',
    width: '90%',
    maxWidth: '900px',
    minHeight: '180px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
};

export const introHeadingStyles = {
    fontSize: '1.7rem',
    color: colors.accentColor,
    marginBottom: '15px',
    fontFamily: 'orbitron_medium',
};

export const introSubHeadingStyles = {
    fontSize: '1.3rem',
    color: colors.textColor,
    marginBottom: '20px',
    fontFamily: 'roboto_regular',
    maxWidth: '600px',
};

export const introSubHeadingStyles2 = {
    fontSize: '1rem',
    color: colors.textColor,
    marginBottom: '20px',
    fontFamily: 'roboto_regular',
    maxWidth: '600px',
};

export const outroQuoteStyle = {
    fontSize: '1.3rem',
    color: colors.accentColor,
    marginBottom: '15px',
    fontFamily: 'orbitron_medium',
};

export const listItemStyles = {
    textAlign: 'left',
    paddingLeft: '20px',
    alignSelf: 'flex-start',
    maxWidth: '600px',
    width: '100%',
    listStyle: 'disc',
    listStylePosition: 'outside',
    fontSize: '1.3rem',
    fontFamily: 'roboto_regular, sans-serif',
    color: colors.textColor,
};


// --- Styled Components (CSS-in-JS) ---
export const StyledMissionList = styled.ul`
    list-style: none; /* Crucial: removes default bullets */
    padding-left: 0;
    font-size: 1.5rem;
    font-family: 'roboto_regular', sans-serif;
`;

export const StyledMissionListItem = styled.li`
    position: relative;
    padding-left: 40px; /* Space for the icon + gap */
    margin-bottom: 8px;
    font-size: 1.3rem;
    font-family: 'orbitron_regular', sans-serif;
    line-height: 1.2;

    &::before {
        content: ""; /* Must be present */
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%); /* For perfect vertical centering */
        width: 16px; /* Adjust size of your icon */
        height: 16px; /* Adjust size of your icon */
        background-image: url(${rocketIcon}); /* Uses the imported image */
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
    }
`;